export var ETwoFactorPhoneActionTypes = /*#__PURE__*/function (ETwoFactorPhoneActionTypes) {
  ETwoFactorPhoneActionTypes["SendCodeFailed"] = "twoFactorPhone/sendCode/failed";
  ETwoFactorPhoneActionTypes["SendCodeSucceed"] = "twoFactorPhone/sendCode/succeed";
  ETwoFactorPhoneActionTypes["SendCodeLoading"] = "twoFactorPhone/sendCode/loading";
  ETwoFactorPhoneActionTypes["PhoneChanged"] = "twoFactorPhone/phone/changed";
  ETwoFactorPhoneActionTypes["AutosubmitChanged"] = "twoFactorPhone/autosubmit/changed";
  return ETwoFactorPhoneActionTypes;
}({});